// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu-icon--2DZ8h{display:inline-block;margin-right:20px;position:relative;top:1px;width:16px}\n", ""]);
// Exports
exports.locals = {
	"menu-icon": "menu-icon--2DZ8h"
};
module.exports = exports;
